import styled from 'styled-components'

export const Container = styled.div<{width: string}>`
    display: flex;
    flex-direction: column;
    width: ${(props) => props.width};
    margin-bottom: 1rem;
`
export const Title = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: .6rem;
`
